/*-
 * ╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲
 * Sentry Maven Skin
 * ჻჻჻჻჻჻
 * Copyright (C) 2017 - 2024 Sentry Software
 * ჻჻჻჻჻჻
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱╲╱
 */
/**
 * truncate, a small filter
 * Example:
 * {{ 'abcdefghijklmnopqrstuvwxyz' | truncate:'3' }}
 * ==> abc...
 **/
angular.module("sentry.site").filter("truncate", [
	function () {
		return function (s, limit) {
			// Not a string?
			if (!angular.isString(s)) {
				return "";
			}

			// String already shorter than limit?
			if (s.length < limit) {
				return s;
			}

			// Truncate
			return s.substring(0, limit) + "...";
		};
	}
]);
